/**
 * @generated SignedSource<<d8f6f2d5a94b5e4ab365c0b0d82ba964>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ServiceMutationsHighlightedItemAddServiceMutation$variables = {
  pid: string;
  sid: string;
};
export type ServiceMutationsHighlightedItemAddServiceMutation$data = {
  readonly addHighlightedSeaService: boolean;
};
export type ServiceMutationsHighlightedItemAddServiceMutation = {
  response: ServiceMutationsHighlightedItemAddServiceMutation$data;
  variables: ServiceMutationsHighlightedItemAddServiceMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'pid',
      },
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'sid',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'pid',
            variableName: 'pid',
          },
          {
            kind: 'Variable',
            name: 'sid',
            variableName: 'sid',
          },
        ],
        kind: 'ScalarField',
        name: 'addHighlightedSeaService',
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'ServiceMutationsHighlightedItemAddServiceMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'ServiceMutationsHighlightedItemAddServiceMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '4f8547ded8cdf74dc384ef8f369bd176',
      id: null,
      metadata: {},
      name: 'ServiceMutationsHighlightedItemAddServiceMutation',
      operationKind: 'mutation',
      text: 'mutation ServiceMutationsHighlightedItemAddServiceMutation(\n  $pid: ID!\n  $sid: ID!\n) {\n  addHighlightedSeaService(pid: $pid, sid: $sid)\n}\n',
    },
  };
})();

(node as any).hash = '13114f7e9106598ace52efbf10ab9116';

export default node;
